/**
 * PRICE LIST DATABASE
 * Base prices only - NO discounts
 * Your team will apply discounts manually when responding
 */

export const priceList = {
  cables: {
    domestic: {
      name: 'Domestic Cables',
      icon: '🏠',
      description: 'House wiring cables',
      products: [
        {
          id: 'dom-1.0',
          name: '1.0mm² Domestic Cable',
          sizes: ['1.0mm²'],
          colors: ['Red', 'Black', 'Yellow/Green'],
          packaging: [
            { type: 'Roll', unit: 'meter', length: 90, price: 4050 }, // 90m × 45
            { type: 'Roll', unit: 'meter', length: 100, price: 4500 } // 100m × 45
          ],
          unitPrice: 45, // per meter
          voltage: '450/750V',
          standard: 'KS EAS 114'
        },
        {
          id: 'dom-1.5',
          name: '1.5mm² Domestic Cable',
          sizes: ['1.5mm²'],
          colors: ['Red', 'Black', 'Yellow/Green', 'Blue'],
          packaging: [
            { type: 'Roll', unit: 'meter', length: 90, price: 5850 }, // 90m × 65
            { type: 'Roll', unit: 'meter', length: 100, price: 6500 } // 100m × 65
          ],
          unitPrice: 65, // per meter
          voltage: '450/750V',
          standard: 'KS EAS 114'
        },
        {
          id: 'dom-2.5',
          name: '2.5mm² Domestic Cable',
          sizes: ['2.5mm²'],
          colors: ['Red', 'Black', 'Yellow/Green', 'Blue', 'Brown'],
          packaging: [
            { type: 'Roll', unit: 'meter', length: 90, price: 8550 }, // 90m × 95
            { type: 'Roll', unit: 'meter', length: 100, price: 9500 } // 100m × 95
          ],
          unitPrice: 95, // per meter
          voltage: '450/750V',
          standard: 'KS EAS 114'
        },
        {
          id: 'dom-4.0',
          name: '4.0mm² Domestic Cable',
          sizes: ['4.0mm²'],
          colors: ['Red', 'Black', 'Yellow/Green'],
          packaging: [
            { type: 'Roll', unit: 'meter', length: 90, price: 13050 }, // 90m × 145
            { type: 'Roll', unit: 'meter', length: 100, price: 14500 } // 100m × 145
          ],
          unitPrice: 145, // per meter
          voltage: '450/750V',
          standard: 'KS EAS 114'
        },
        {
          id: 'dom-6.0',
          name: '6.0mm² Domestic Cable',
          sizes: ['6.0mm²'],
          colors: ['Yellow/Green'],
          packaging: [
            { type: 'Roll', unit: 'meter', length: 90, price: 18900 }, // 90m × 210
            { type: 'Roll', unit: 'meter', length: 100, price: 21000 } // 100m × 210
          ],
          unitPrice: 210, // per meter
          voltage: '450/750V',
          standard: 'KS EAS 114'
        },
        {
          id: 'dom-10.0',
          name: '10.0mm² Domestic Cable',
          sizes: ['10.0mm²'],
          colors: ['Red', 'Black', 'Yellow/Green'],
          packaging: [
            { type: 'Roll', unit: 'meter', length: 90, price: 31500 }, // 90m × 350
            { type: 'Roll', unit: 'meter', length: 100, price: 35000 } // 100m × 350
          ],
          unitPrice: 350, // per meter
          voltage: '450/750V',
          standard: 'KS EAS 114'
        }
      ]
    },

    submersible: {
      name: 'Submersible Cables',
      icon: '💧',
      description: 'Water-resistant cables for borehole pumps',
      products: [
        {
          id: 'sub-1.5-3c',
          name: '1.5mm² 3-Core Submersible Cable',
          sizes: ['1.5mm²'],
          cores: '3 Core',
          packaging: [
            { type: 'Coil', unit: 'meter', length: 50, price: 9000 }, // 50m × 180
            { type: 'Coil', unit: 'meter', length: 100, price: 18000 } // 100m × 180
          ],
          unitPrice: 180, // per meter
          voltage: '600/1000V',
          standard: 'KS IEC 60502-1'
        },
        {
          id: 'sub-2.5-3c',
          name: '2.5mm² 3-Core Submersible Cable',
          sizes: ['2.5mm²'],
          cores: '3 Core',
          packaging: [
            { type: 'Coil', unit: 'meter', length: 50, price: 12500 }, // 50m × 250
            { type: 'Coil', unit: 'meter', length: 100, price: 25000 } // 100m × 250
          ],
          unitPrice: 250, // per meter
          voltage: '600/1000V',
          standard: 'KS IEC 60502-1'
        },
        {
          id: 'sub-4.0-3c',
          name: '4.0mm² 3-Core Submersible Cable',
          sizes: ['4.0mm²'],
          cores: '3 Core',
          packaging: [
            { type: 'Coil', unit: 'meter', length: 50, price: 19000 }, // 50m × 380
            { type: 'Coil', unit: 'meter', length: 100, price: 38000 } // 100m × 380
          ],
          unitPrice: 380, // per meter
          voltage: '600/1000V',
          standard: 'KS IEC 60502-1'
        },
        {
          id: 'sub-1.5-4c',
          name: '1.5mm² 4-Core Submersible Cable',
          sizes: ['1.5mm²'],
          cores: '4 Core',
          packaging: [
            { type: 'Coil', unit: 'meter', length: 50, price: 10500 }, // 50m × 210
            { type: 'Coil', unit: 'meter', length: 100, price: 21000 } // 100m × 210
          ],
          unitPrice: 210, // per meter
          voltage: '600/1000V',
          standard: 'KS IEC 60502-1'
        },
        {
          id: 'sub-2.5-4c',
          name: '2.5mm² 4-Core Submersible Cable',
          sizes: ['2.5mm²'],
          cores: '4 Core',
          packaging: [
            { type: 'Coil', unit: 'meter', length: 50, price: 14500 }, // 50m × 290
            { type: 'Coil', unit: 'meter', length: 100, price: 29000 } // 100m × 290
          ],
          unitPrice: 290, // per meter
          voltage: '600/1000V',
          standard: 'KS IEC 60502-1'
        }
      ]
    },

    armoured: {
      name: 'Armoured Cables',
      icon: '🛡️',
      description: 'Steel wire armoured for industrial use',
      products: [
        {
          id: 'arm-al-4c-10',
          name: '4C 10mm² Aluminium Armoured Cable',
          sizes: ['10mm²'],
          cores: '4 Core',
          conductor: 'Aluminium',
          packaging: [
            { type: 'Drum', unit: 'meter', length: 100, price: 32000 }, // 100m × 320
            { type: 'Drum', unit: 'meter', length: 250, price: 80000 } // 250m × 320
          ],
          unitPrice: 320, // per meter
          voltage: '600/1000V',
          standard: 'KS IEC 60502-1'
        },
        {
          id: 'arm-al-4c-16',
          name: '4C 16mm² Aluminium Armoured Cable',
          sizes: ['16mm²'],
          cores: '4 Core',
          conductor: 'Aluminium',
          packaging: [
            { type: 'Drum', unit: 'meter', length: 100, price: 45000 }, // 100m × 450
            { type: 'Drum', unit: 'meter', length: 250, price: 112500 } // 250m × 450
          ],
          unitPrice: 450, // per meter
          voltage: '600/1000V',
          standard: 'KS IEC 60502-1'
        },
        {
          id: 'arm-al-4c-25',
          name: '4C 25mm² Aluminium Armoured Cable',
          sizes: ['25mm²'],
          cores: '4 Core',
          conductor: 'Aluminium',
          packaging: [
            { type: 'Drum', unit: 'meter', length: 100, price: 62000 }, // 100m × 620
            { type: 'Drum', unit: 'meter', length: 250, price: 155000 } // 250m × 620
          ],
          unitPrice: 620, // per meter
          voltage: '600/1000V',
          standard: 'KS IEC 60502-1'
        },
        {
          id: 'arm-cu-4c-10',
          name: '4C 10mm² Copper Armoured Cable',
          sizes: ['10mm²'],
          cores: '4 Core',
          conductor: 'Copper',
          packaging: [
            { type: 'Drum', unit: 'meter', length: 100, price: 58000 }, // 100m × 580
            { type: 'Drum', unit: 'meter', length: 250, price: 145000 } // 250m × 580
          ],
          unitPrice: 580, // per meter
          voltage: '600/1000V',
          standard: 'KS IEC 60502-1'
        }
      ]
    },

    welding: {
      name: 'Welding Cables',
      icon: '⚡',
      description: 'Flexible cables for welding applications',
      products: [
        {
          id: 'weld-16',
          name: '16mm² Welding Cable',
          sizes: ['16mm²'],
          packaging: [
            { type: 'Coil', unit: 'meter', length: 50, price: 14000 }, // 50m × 280
            { type: 'Coil', unit: 'meter', length: 100, price: 28000 } // 100m × 280
          ],
          unitPrice: 280, // per meter
          voltage: '600/1000V',
          standard: 'BS 638'
        },
        {
          id: 'weld-25',
          name: '25mm² Welding Cable',
          sizes: ['25mm²'],
          packaging: [
            { type: 'Coil', unit: 'meter', length: 50, price: 21000 }, // 50m × 420
            { type: 'Coil', unit: 'meter', length: 100, price: 42000 } // 100m × 420
          ],
          unitPrice: 420, // per meter
          voltage: '600/1000V',
          standard: 'BS 638'
        },
        {
          id: 'weld-35',
          name: '35mm² Welding Cable',
          sizes: ['35mm²'],
          packaging: [
            { type: 'Coil', unit: 'meter', length: 50, price: 28000 }, // 50m × 560
            { type: 'Coil', unit: 'meter', length: 100, price: 56000 } // 100m × 560
          ],
          unitPrice: 560, // per meter
          voltage: '600/1000V',
          standard: 'BS 638'
        },
        {
          id: 'weld-50',
          name: '50mm² Welding Cable',
          sizes: ['50mm²'],
          packaging: [
            { type: 'Coil', unit: 'meter', length: 50, price: 39000 }, // 50m × 780
            { type: 'Coil', unit: 'meter', length: 100, price: 78000 } // 100m × 780
          ],
          unitPrice: 780, // per meter
          voltage: '600/1000V',
          standard: 'BS 638'
        }
      ]
    },

    flexible: {
      name: 'Flexible Cables',
      icon: '〰️',
      description: 'Flexible cables for industrial applications',
      products: [
        {
          id: 'flex-2.5-2c',
          name: '2.5mm² 2-Core Flexible Cable',
          sizes: ['2.5mm²'],
          cores: '2 Core',
          packaging: [
            { type: 'Coil', unit: 'meter', length: 50, price: 7000 }, // 50m × 140
            { type: 'Coil', unit: 'meter', length: 100, price: 14000 } // 100m × 140
          ],
          unitPrice: 140, // per meter
          voltage: '450/750V',
          standard: 'KS EAS 117'
        },
        {
          id: 'flex-4.0-2c',
          name: '4.0mm² 2-Core Flexible Cable',
          sizes: ['4.0mm²'],
          cores: '2 Core',
          packaging: [
            { type: 'Coil', unit: 'meter', length: 50, price: 10500 }, // 50m × 210
            { type: 'Coil', unit: 'meter', length: 100, price: 21000 } // 100m × 210
          ],
          unitPrice: 210, // per meter
          voltage: '450/750V',
          standard: 'KS EAS 117'
        },
        {
          id: 'flex-2.5-3c',
          name: '2.5mm² 3-Core Flexible Cable',
          sizes: ['2.5mm²'],
          cores: '3 Core',
          packaging: [
            { type: 'Coil', unit: 'meter', length: 50, price: 9750 }, // 50m × 195
            { type: 'Coil', unit: 'meter', length: 100, price: 19500 } // 100m × 195
          ],
          unitPrice: 195, // per meter
          voltage: '450/750V',
          standard: 'KS EAS 117'
        }
      ]
    },

    abc: {
      name: 'ABC Cables',
      icon: '☁️',
      description: 'Aerial bundled cables for overhead distribution',
      products: [
        {
          id: 'abc-3c-50',
          name: 'ABC 3C 50 + 54.6 SqMm',
          sizes: ['50mm² + 54.6mm²'],
          cores: '3 Core',
          packaging: [
            { type: 'Drum', unit: 'meter', length: 100, price: 45000 }, // 100m × 450
            { type: 'Drum', unit: 'meter', length: 500, price: 225000 } // 500m × 450
          ],
          unitPrice: 450, // per meter
          voltage: '600/1000V',
          standard: 'KS 2650'
        },
        {
          id: 'abc-2c-10',
          name: 'ABC 2C 10mm²',
          sizes: ['10mm²'],
          cores: '2 Core',
          packaging: [
            { type: 'Drum', unit: 'meter', length: 100, price: 12000 }, // 100m × 120
            { type: 'Drum', unit: 'meter', length: 500, price: 60000 } // 500m × 120
          ],
          unitPrice: 120, // per meter
          voltage: '600/1000V',
          standard: 'KS 2650'
        },
        {
          id: 'abc-2c-16',
          name: 'ABC 2C 16mm²',
          sizes: ['16mm²'],
          cores: '2 Core',
          packaging: [
            { type: 'Drum', unit: 'meter', length: 100, price: 18000 }, // 100m × 180
            { type: 'Drum', unit: 'meter', length: 500, price: 90000 } // 500m × 180
          ],
          unitPrice: 180, // per meter
          voltage: '600/1000V',
          standard: 'KS 2650'
        }
      ]
    },

    automotive: {
      name: 'Automotive Cables',
      icon: '🚗',
      description: 'PVC covered conductors for vehicles',
      products: [
        {
          id: 'auto-0.5',
          name: '0.5mm² Automotive Cable',
          sizes: ['0.5mm²'],
          colors: ['Black', 'Red', 'White', 'Yellow', 'Green', 'Blue', 'Brown'],
          packaging: [
            { type: 'Coil', unit: 'meter', length: 100, price: 1800 }, // 100m × 18
            { type: 'Coil', unit: 'meter', length: 500, price: 9000 } // 500m × 18
          ],
          unitPrice: 18, // per meter
          voltage: 'Low Voltage',
          standard: 'KS 04-314'
        },
        {
          id: 'auto-0.75',
          name: '0.75mm² Automotive Cable',
          sizes: ['0.75mm²'],
          colors: ['Black', 'Red', 'White', 'Green', 'Blue'],
          packaging: [
            { type: 'Coil', unit: 'meter', length: 100, price: 2400 }, // 100m × 24
            { type: 'Coil', unit: 'meter', length: 500, price: 12000 } // 500m × 24
          ],
          unitPrice: 24, // per meter
          voltage: 'Low Voltage',
          standard: 'KS 04-314'
        },
        {
          id: 'auto-1.0',
          name: '1.0mm² Automotive Cable',
          sizes: ['1.0mm²'],
          colors: ['Black', 'Red', 'White', 'Blue'],
          packaging: [
            { type: 'Coil', unit: 'meter', length: 100, price: 3200 }, // 100m × 32
            { type: 'Coil', unit: 'meter', length: 500, price: 16000 } // 500m × 32
          ],
          unitPrice: 32, // per meter
          voltage: 'Low Voltage',
          standard: 'KS 04-314'
        }
      ]
    }
  },

  steel: {
    tmt: {
      name: 'TMT Steel Bars',
      icon: '🏗️',
      description: 'Construction grade reinforcement bars',
      products: [
        {
          id: 'tmt-8',
          name: '8mm TMT Bar (Fe-500)',
          sizes: ['8mm'],
          grade: 'Fe-500',
          length: '12m',
          weight: '0.395 kg/m',
          packaging: [
            { type: 'Piece', unit: 'piece', length: 12, price: 850 },
            { type: 'Bundle', unit: 'pieces', quantity: 10, price: 8500 },
            { type: 'Bundle', unit: 'pieces', quantity: 20, price: 17000 }
          ],
          unitPrice: 850 // per 12m piece
        },
        {
          id: 'tmt-10',
          name: '10mm TMT Bar (Fe-500)',
          sizes: ['10mm'],
          grade: 'Fe-500',
          length: '12m',
          weight: '0.617 kg/m',
          packaging: [
            { type: 'Piece', unit: 'piece', length: 12, price: 1320 },
            { type: 'Bundle', unit: 'pieces', quantity: 10, price: 13200 },
            { type: 'Bundle', unit: 'pieces', quantity: 20, price: 26400 }
          ],
          unitPrice: 1320 // per 12m piece
        },
        {
          id: 'tmt-12',
          name: '12mm TMT Bar (Fe-500)',
          sizes: ['12mm'],
          grade: 'Fe-500',
          length: '12m',
          weight: '0.888 kg/m',
          packaging: [
            { type: 'Piece', unit: 'piece', length: 12, price: 1900 },
            { type: 'Bundle', unit: 'pieces', quantity: 10, price: 19000 },
            { type: 'Bundle', unit: 'pieces', quantity: 20, price: 38000 }
          ],
          unitPrice: 1900 // per 12m piece
        },
        {
          id: 'tmt-16',
          name: '16mm TMT Bar (Fe-500)',
          sizes: ['16mm'],
          grade: 'Fe-500',
          length: '12m',
          weight: '1.58 kg/m',
          packaging: [
            { type: 'Piece', unit: 'piece', length: 12, price: 3350 },
            { type: 'Bundle', unit: 'pieces', quantity: 10, price: 33500 }
          ],
          unitPrice: 3350 // per 12m piece
        }
      ]
    },

    angles: {
      name: 'Angle Bars',
      icon: '📐',
      description: 'Equal angle sections',
      products: [
        {
          id: 'angle-25x25x3',
          name: '25mm x 25mm x 3mm Angle Bar',
          sizes: ['25x25x3mm'],
          length: '6m',
          packaging: [
            { type: 'Piece', unit: 'piece', length: 6, price: 1850 },
            { type: 'Bundle', unit: 'pieces', quantity: 10, price: 18500 }
          ],
          unitPrice: 1850 // per 6m piece
        },
        {
          id: 'angle-40x40x3',
          name: '40mm x 40mm x 3mm Angle Bar',
          sizes: ['40x40x3mm'],
          length: '6m',
          packaging: [
            { type: 'Piece', unit: 'piece', length: 6, price: 3200 },
            { type: 'Bundle', unit: 'pieces', quantity: 10, price: 32000 }
          ],
          unitPrice: 3200 // per 6m piece
        }
      ]
    }
  },

  pumps: {
    submersible: {
      name: 'Submersible Pumps',
      icon: '🌊',
      description: 'Borehole and deep well pumps',
      products: [
        {
          id: 'pump-sub-0.75',
          name: '0.75kW (1HP) 4" Submersible Pump',
          power: '0.75kW (1HP)',
          voltage: '230V',
          maxHead: '45m',
          flow: '1.5 m³/hr',
          outlet: '1¼"',
          packaging: [
            { type: 'Unit', unit: 'piece', quantity: 1, price: 28500 }
          ],
          unitPrice: 28500
        },
        {
          id: 'pump-sub-1.1',
          name: '1.1kW (1.5HP) 4" Submersible Pump',
          power: '1.1kW (1.5HP)',
          voltage: '230V',
          maxHead: '60m',
          flow: '2.0 m³/hr',
          outlet: '1¼"',
          packaging: [
            { type: 'Unit', unit: 'piece', quantity: 1, price: 34500 }
          ],
          unitPrice: 34500
        },
        {
          id: 'pump-sub-1.5',
          name: '1.5kW (2HP) 4" Submersible Pump',
          power: '1.5kW (2HP)',
          voltage: '230V/400V',
          maxHead: '80m',
          flow: '3.0 m³/hr',
          outlet: '1½"',
          packaging: [
            { type: 'Unit', unit: 'piece', quantity: 1, price: 42500 }
          ],
          unitPrice: 42500
        }
      ]
    },
    monoblock: {
      name: 'Mono Block Pumps',
      icon: '⚙️',
      description: 'Surface pumps for domestic use',
      products: [
        {
          id: 'pump-mono-0.75',
          name: '0.75kW (1HP) Mono Block Pump',
          power: '0.75kW (1HP)',
          voltage: '230V',
          maxHead: '25m',
          flow: '2.4 m³/hr',
          outlet: '1¼"',
          packaging: [
            { type: 'Unit', unit: 'piece', quantity: 1, price: 18500 }
          ],
          unitPrice: 18500
        },
        {
          id: 'pump-mono-1.1',
          name: '1.1kW (1.5HP) Mono Block Pump',
          power: '1.1kW (1.5HP)',
          voltage: '230V',
          maxHead: '30m',
          flow: '3.0 m³/hr',
          outlet: '1¼"',
          packaging: [
            { type: 'Unit', unit: 'piece', quantity: 1, price: 22500 }
          ],
          unitPrice: 22500
        },
        {
          id: 'pump-mono-1.5',
          name: '1.5kW (2HP) Mono Block Pump',
          power: '1.5kW (2HP)',
          voltage: '230V/400V',
          maxHead: '35m',
          flow: '4.2 m³/hr',
          outlet: '1½"',
          packaging: [
            { type: 'Unit', unit: 'piece', quantity: 1, price: 27500 }
          ],
          unitPrice: 27500
        }
      ]
    }
  }
};

// Helper function to get all top-level categories
export const getMainCategories = () => {
  return Object.keys(priceList).map(key => ({
    id: key,
    name: key === 'cables' ? 'Cables' : key === 'steel' ? 'Steel' : 'Pumps',
    icon: key === 'cables' ? '⚡' : key === 'steel' ? '🔩' : '💧',
    subCategories: Object.keys(priceList[key]).map(subKey => ({
      id: subKey,
      ...priceList[key][subKey]
    }))
  }));
};

// Helper function to get a specific product by ID
export const getProductById = (productId) => {
  for (const category of Object.keys(priceList)) {
    for (const subCategory of Object.keys(priceList[category])) {
      const product = priceList[category][subCategory].products.find(p => p.id === productId);
      if (product) {
        return {
          ...product,
          category: subCategory,
          categoryName: priceList[category][subCategory].name,
          mainCategory: category
        };
      }
    }
  }
  return null;
};

// Helper function to get all products in a subcategory
export const getProductsBySubCategory = (mainCategory, subCategory) => {
  if (priceList[mainCategory] && priceList[mainCategory][subCategory]) {
    return priceList[mainCategory][subCategory].products;
  }
  return [];
};

export default priceList;